import { Component } from '@angular/core';

@Component({
  selector: 'app-sso-required',
  templateUrl: './sso-required.component.html',
  styleUrls: ['./sso-required.component.scss']
})
export class SsoRequiredComponent {}
